import {callHandlers} from '@baidu/health-tool-box-bridge';
import {post} from '@/utils/fetch';

import {ASYNC_UILS} from '@/dicts/fetchUrls';
import {isDoctorApp, getPageBaseUrl} from '@/utils/utils';


const prefxiAPI = process.env.PREFIX_ASYNC_API || getPageBaseUrl();

export interface TopicMyVoteQuery {
    id: string;
    moduleId: number;
    fieldValue: {
        channel: string;
        client: string;
    };
    itemId?: number;
    captcha?: any;
}

export interface TopicMyVoteResponse {
    code: TopicMyVoteResponse;
    availableVoteNum: number;
    activityInfo: {
        status: 1 |2 |3;
    };
}

export interface VoteData {

}

export const getMyVotes = async (query: TopicMyVoteQuery) => {
    // eslint-disable-next-line max-len
    const result = await post<TopicMyVoteResponse, TopicMyVoteQuery>(`${prefxiAPI}${ASYNC_UILS.TOPIC_MY_VOTE}`, query);
    return result;
};

export const updateVote = async (query: TopicMyVoteQuery, options: any) => {
    if (isDoctorApp()) {
        const data = await callHandlers.common.getRequestHeaders();
        const headers = data?.data;
        options.headers = Object.assign({}, options.headers, headers);
    }
    // eslint-disable-next-line max-len
    const result = await post<TopicMyVoteResponse, TopicMyVoteQuery>(`${prefxiAPI}${ASYNC_UILS.TOPIC_UPDATE_VOTE}`, query, true, false, options);
    return result;
};
